module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "author"
    }
  }), _vm._v("AUTHOR’S NOTE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When I wrote this novel initially, I felt restricted by the proximity of its story to the environment and events of my recent past decade. This might account for the cryptic tone of the novel’s first version.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Now, years later, in this revised and expanded edition, I have felt free to reinstate all the additional links that bound Jonathan James Whalen to those whom he loved.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERZY")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSINSKI")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53431d69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/author.vue
// module id = 78
// module chunks = 0